let dataL = document.querySelector('.listing__results');
let dataLText;
if (dataL) {
    dataLText = dataL.getAttribute('data-linkurltext');
}

const newsCard = ({ title, category, date, imgURL, altText, url }) => `
    <a aria-label="${title}" href="${url}" class="article-card">
        <div class="article-card__header">
            <img class="article-card__image" alt="${altText}" src="${imgURL}">
        </div>
        <div class="article-card__body">
            <span class="article-card__tagline">${category}</span>
            <h3 class="h5 article-card__title">${title}</h3>
            <p class="article-card__date">${date}</p>
        </div>
    </div>
`;

export { newsCard };
